var render = function render(){var _vm=this,_c=_vm._self._c;return _c('person-form',{ref:"form",attrs:{"companyModels":_vm.companyModels,"hideAddress":_vm.hideAddress,"hideCompany":_vm.hideCompany},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }